import React, { Component } from 'react';
import OdeGraphMain from "./odeGraphMain";

class App extends Component {

  render(){
    //var bg=require("../images/cfdrcBlue.jpg");
    //const theContainerWidth = { width: 1200 };

    return(
      <div style={styles.InputContainer}>
        <div style={styles.Header}>
          <p>Drug Dissolution in Transwell</p>
        </div>
        <div style={styles.Mainbody}>
          <OdeGraphMain/>
        </div>
      </div>

  );
}

}


export default (App)


const styles = {
  InputContainer:{
    width: '100%',
    height: '100%',
    marginLeft:0,
  	marginRight:0,
  	marginTop: 0,
    //backgroundColor: 'transparent',
    backgroundColor: '#01759b',
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',

},

Header:{
  height: '10%',
  color:'white',
  width: '100%',
  fontSize: 40,
  //fontFamily: ,,
  textAlign: 'center',
  fontFamily: 'Tahoma',
  fontStyle: 'italic',
  backgroundColor: '#132F57',
},

Mainbody:{
  height: 750,
  flexDirection: 'row',
  justifyContent: 'center',
  textAlign: 'center',
  display: 'flex',
  baclgroundColor: "transparent",
//  overflow: auto,
},

Menu: {
	height: 60,
	backgroundColor:'#DBDDE8',

},

MenuUL:{
	margin:0,
	padding:0,
},
MenuLI: {
  textDecoration: 'none',
  listStyleType: 'none',
	float:'left',
	display: 'block',
	width: 150,
	height: 60,
  textAlign: 'center',
	//lineHeight: 55,
	fontFamily: 'Tahoma',

},
MenuLIA: {
  textDecoration: 'none',
	color:'black',
  fontFamily: 'Tahoma',
  textAlign: 'center',
  fontSize:22,
  fontWeight: 'bold',

},

MenuLIHover: {
	backgroundColor:'green',
}
}



// WEBPACK FOOTER //
// ./src/components/App.js